export default __webpack_public_path__ + "static/media/showRoom_top_img.be7d0906.png";